import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewIntegration.integrationApp.title',
    defaultMessage: 'App',
    description: 'Title of the integration app on the integration view',
  },
  properties: {
    name: {
      id: 'properties.name',
      defaultMessage: 'Name',
      description: 'Label of the property name',
    },
    description: {
      id: 'properties.description',
      defaultMessage: 'Description',
      description: 'Label of the property description',
    },
    authorName: {
      id: 'properties.authorName',
      defaultMessage: 'Author name',
      description: 'Label of the property author name',
    },
    multipleIntegrationsAllowed: {
      id: 'properties.multipleIntegrationsAllowed',
      defaultMessage: 'Multiple integrations allowed',
      description: 'Label of the property multiple integrations allowed',
    },
    tags: {
      id: 'properties.tags',
      defaultMessage: 'Tags',
      description: 'Label of the property tags',
    },
  },
};

export default defineMessages(translations);
